export default {
  SHOW: 'SHOW',
  UPDATE: 'UPDATE',
  HIDE: 'HIDE',
  CONFIGURE: 'CONFIGURE',
}
